export function validateJSONSchema(input: string) {
  try {
    return JSON.parse(input)
  } catch {
    return null
  }
}

export const isValidJSONSchema = (input: string): boolean => {
  return validateJSONSchema(input) !== null
}
